export let DeliveryUserGroup = /*#__PURE__*/function (DeliveryUserGroup) {
  DeliveryUserGroup["Delivery"] = "Delivery";
  DeliveryUserGroup["DeliveryAdmin"] = "Delivery Admin";
  return DeliveryUserGroup;
}({});